import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import address from 'redux/reducer/address/addressReducer';
import branch from 'redux/reducer/basicData/branchReducer';
import city from 'redux/reducer/basicData/cityReducer';
import province from 'redux/reducer/basicData/provinceReducer';
import myPackages from 'redux/reducer/branchPackaging/branchPackagingReducer';
import client from 'redux/reducer/client/clientReducer';
import customerBranchProduct from 'redux/reducer/customerBranchProduct/customerBranchProductReducer';
import financial from 'redux/reducer/Financial/financialReducers';
import forgetPasswordStore from 'redux/reducer/ForgetPassword/forgetPasswordReducer';
import ltl from 'redux/reducer/Ltl/LTLReducer';
import map from 'redux/reducer/MapReducer/mapReducer';
import notification from 'redux/reducer/notification/notificationReducer';
import packaging from 'redux/reducer/packaging/packagingReducer';
import parcelOrder from 'redux/reducer/ParcelOrder/parcelOrderReducer';
import setting from 'redux/reducer/Setting/settingReducer';
import ticketCategory from 'redux/reducer/Ticket/ticketCategoryReducer';
import ticket from 'redux/reducer/Ticket/ticketReducer';
import user from 'redux/reducer/user/userReducer';
import userBranches from 'redux/reducer/UserBranches/UserBranchesReducer';
import voucher from 'redux/reducer/voucher/voucherReducer';

export const store = configureStore({
  reducer: {
    user,
    setting,
    branch,
    city,
    province,
    client,
    ticket,
    ticketCategory,
    userBranches,
    parcelOrder,
    packaging,
    address,
    myPackages,
    ltl,
    notification,
    map,
    voucher,
    financial,
    forgetPasswordStore,
    customerBranchProduct,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk = (_dispatch: AppDispatch) => void;
export const useAppDispatch = () => useDispatch<AppDispatch>();
